import { NONE_OPTION } from '../../../../../../../constants'

import { form } from '../../../../formState'

import { useDropdownOptions } from './hooks/useDropdownOptions'
import { useTexts } from './hooks/useTexts'

export function Company() {
  const values = useDropdownOptions(NONE_OPTION)
  const texts = useTexts()

  return (
    <form.SimpleSelect
      name="order.companyId"
      options={values}
      testId="company"
      label={texts.label}
      initialValue={NONE_OPTION}
    />
  )
}
